import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onChange, noUpperCase, ...props }, ref) => {
  // Determine if uppercase should be skipped for this input type
  const skipUpperCase = noUpperCase || 
    type === 'email' || 
    type === 'password' || 
    type === 'number' || 
    type === 'date' ||
    type === 'datetime-local' ||
    type === 'time' ||
    type === 'file' ||
    type === 'search';
  
  // Handle uppercase conversion for text inputs (unless disabled or type is excluded)
  const handleChange = (e) => {
    if (!skipUpperCase && e.target && typeof e.target.value === 'string') {
      e.target.value = e.target.value.toUpperCase();
    }
    
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // Only apply uppercase CSS for non-excluded types
        !skipUpperCase && "uppercase",
        className
      )}
      ref={ref}
      onChange={handleChange}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
